import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { api, errMsg, timeAgo } from "@/lib/api";
import { Avatar } from "@/components/common";

function Comment({ c, replies, onReply, onDelete, me }) {
  return (
    <div className="flex gap-2.5" data-testid={`comment-${c.id}`}>
      <Avatar src={c.user?.avatar} name={c.user?.name} size="h-8 w-8" />
      <div className="min-w-0 flex-1">
        <p className="text-sm"><Link to={`/profile/${c.user_id}`} className="mr-1.5 font-semibold">{c.user?.name}</Link>{c.text}</p>
        <div className="mt-0.5 flex gap-3 text-[11px] text-[#A8A29E]">
          <span>{timeAgo(c.created_at)}</span>
          <button onClick={() => onReply(c)} className="font-semibold hover:text-[#6B1D2F]" data-testid={`comment-reply-${c.id}`}>Reply</button>
          {me && (me.id === c.user_id || me.role !== "user") && <button onClick={() => onDelete(c.id)} className="hover:text-red-600">Delete</button>}
        </div>
        {replies?.length > 0 && <div className="mt-3 space-y-3 border-l-2 border-[#F3D2D9] pl-3">{replies.map((r) => (
          <div key={r.id} className="flex gap-2.5" data-testid={`comment-${r.id}`}>
            <Avatar src={r.user?.avatar} name={r.user?.name} size="h-7 w-7" />
            <div className="min-w-0 flex-1"><p className="text-sm"><Link to={`/profile/${r.user_id}`} className="mr-1.5 font-semibold">{r.user?.name}</Link>{r.text}</p>
              <div className="mt-0.5 flex gap-3 text-[11px] text-[#A8A29E]"><span>{timeAgo(r.created_at)}</span><button onClick={() => onReply(c)} className="font-semibold">Reply</button>{me && (me.id === r.user_id || me.role !== "user") && <button onClick={() => onDelete(r.id)}>Delete</button>}</div></div>
          </div>
        ))}</div>}
      </div>
    </div>
  );
}

export default function CommentsPanel({ postId, onCount }) {
  const { user, requireAuth } = useApp();
  const [list, setList] = useState(null);
  const [text, setText] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  useEffect(() => { api.get(`/posts/${postId}/comments`).then((r) => setList(r.data)); }, [postId]);
  const send = requireAuth(async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const r = await api.post(`/posts/${postId}/comments`, { text, parent_id: replyTo?.id || null });
      setList((l) => [...l, r.data]); setText(""); setReplyTo(null); onCount?.(1);
    } catch (err) { toast.error(errMsg(err)); }
  });
  const del = async (id) => { await api.delete(`/comments/${id}`); setList((l) => l.filter((c) => c.id !== id)); onCount?.(-1); };
  if (!list) return <div className="skeleton h-24 rounded-2xl" />;
  const roots = list.filter((c) => !c.parent_id);
  return (
    <div>
      <div className="max-h-[420px] space-y-4 overflow-y-auto pr-1" data-testid="comments-list">
        {roots.length === 0 && <p className="text-sm text-[#78716C]">Be the first to share some love 🌸</p>}
        {roots.map((c) => <Comment key={c.id} c={c} replies={list.filter((r) => r.parent_id === c.id)} onReply={setReplyTo} onDelete={del} me={user} />)}
      </div>
      <form onSubmit={send} className="mt-4">
        {replyTo && <p className="mb-1 text-xs text-[#78716C]">Replying to {replyTo.user?.name} · <button type="button" onClick={() => setReplyTo(null)} className="underline">cancel</button></p>}
        <div className="flex gap-2">
          <input className="input !rounded-full" placeholder="Add a comment…" value={text} onChange={(e) => setText(e.target.value)} data-testid="comment-input" />
          <button className="btn-maroon" data-testid="comment-submit">Post</button>
        </div>
      </form>
    </div>
  );
}
